import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  BASE_URL,
  getToken,
  getCurrentLanguage,
} from "../../shared/utils.js/utils";

// get  Notes Receivable
export const getNotesReceivable = createAsyncThunk(
  "NoteReceivable/getNotesReceivable",
  async (params = {}, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) throw new Error("No authentication token found");
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append("page", params.page);
      if (params.per_page) queryParams.append("per_page", params.per_page);
      if (params.search) queryParams.append("search", params.search);
      if (params.status) queryParams.append("status", params.status);
      if (params.customer_id)
        queryParams.append("customer_id", params.customer_id);
      if (params.date_between)
        queryParams.append("date_between", params.date_between);
      if (params.due_between)
        queryParams.append("due_between", params.due_between);
      const url = `${BASE_URL}/notes-receivable${queryParams.toString() ? `?${queryParams.toString()}` : ""}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
        },
      });
      return { data: response.data, params };
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to get notes receivable!";
      return rejectWithValue(message);
    }
  },
);

// add note receivable
export const addNoteReceivable = createAsyncThunk(
  "NoteReceivable/addNoteReceivable",
  async (payload, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) throw new Error("No authentication token found");
      const response = await axios.post(
        `${BASE_URL}/notes-receivable`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": currentLang,
            "Content-Type": "application/json",
          },
        },
      );
      return response.data;
    } catch (error) {
      let message =
        error.response?.data?.message || "Failed to add note receivable!";
      if (error.response?.data?.errors) {
        message = JSON.stringify(error.response.data.errors);
      }
      return rejectWithValue(message);
    }
  },
);

// get note receivable details
export const getNoteReceivableDetails = createAsyncThunk(
  "NoteReceivable/getNoteReceivableDetails",
  async (id, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) throw new Error("No authentication token found");
      const response = await axios.get(`${BASE_URL}/notes-receivable/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
        },
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        "Failed to get note receivable details!";
      return rejectWithValue(message);
    }
  },
);

// update note receivable (PUT)
export const updateNoteReceivable = createAsyncThunk(
  "NoteReceivable/updateNoteReceivable",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) throw new Error("No authentication token found");
      const response = await axios.put(
        `${BASE_URL}/notes-receivable/${id}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": currentLang,
            "Content-Type": "application/json",
          },
        },
      );
      return response.data;
    } catch (error) {
      let message =
        error.response?.data?.message || "Failed to update note receivable!";
      if (error.response?.data?.errors) {
        message = JSON.stringify(error.response.data.errors);
      }
      return rejectWithValue(message);
    }
  },
);

// collect note receivable
export const collectNoteReceivable = createAsyncThunk(
  "NoteReceivable/collectNoteReceivable",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) throw new Error("No authentication token found");
      const response = await axios.post(
        `${BASE_URL}/notes-receivable/${id}/collect`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": currentLang,
            "Content-Type": "application/json",
          },
        },
      );
      return response.data;
    } catch (error) {
      let message =
        error.response?.data?.message || "Failed to collect note receivable!";
      if (error.response?.data?.errors) {
        message = JSON.stringify(error.response.data.errors);
      }
      return rejectWithValue(message);
    }
  },
);

// cancel note receivable
export const cancelNoteReceivable = createAsyncThunk(
  "NoteReceivable/cancelNoteReceivable",
  async (id, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) throw new Error("No authentication token found");
      const response = await axios.post(
        `${BASE_URL}/notes-receivable/${id}/cancel`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": currentLang,
            "Content-Type": "application/json",
          },
        },
      );
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to cancel note receivable!";
      return rejectWithValue(message);
    }
  },
);
